export default __webpack_public_path__ + "static/media/E1.fe3b3827.png";